import type {
	BulkCreateNaturalPersonEmploymentDto,
	OneSchemaNaturalPersonRowValueDto,
} from '@dealstack/shared/lib/generated';
import { parseOneSchemaDate } from '@dealstack/shared/lib/format/dates/oneSchemaDate.ts';

const toOptionalIsoDate = (value?: string): string | undefined => {
	const parsed = parseOneSchemaDate(value);

	switch (parsed.status) {
		case 'blank':
			return undefined;
		case 'valid':
			return parsed.date.toISOString();
		case 'invalid':
			return value;
	}
};

export const mapOneSchemaRowToEmployment = (
	row: OneSchemaNaturalPersonRowValueDto
): BulkCreateNaturalPersonEmploymentDto | undefined => {
	const employerName = row.employer?.trim();

	if (!employerName) {
		return undefined;
	}

	return {
		employerName,
		employeeReference: row.employee_id?.trim() || undefined,
		jobTitle: row.job_title?.trim() || undefined,
		startDate: toOptionalIsoDate(row.employment_start_date),
		endDate: toOptionalIsoDate(row.employment_end_date),
	};
};
